import {Injectable, inject, afterNextRender} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {filter} from 'rxjs/operators';
import {environment} from "../../../environments/environment";


// Declare gtag globally so TypeScript compiles without errors
declare const gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  private router = inject(Router);
  private trackingId = "G-J56WF66QMR";

  constructor() {
    // afterNextRender runs strictly on the client browser after the page loads
    afterNextRender(() => {
      if (environment.production) {
        this.initPageTracking();
      }
    });
  }

  private initPageTracking(): void {
    if (typeof gtag !== 'function') {
      console.error('❌ Google Analytics gtag function is missing from index.html!');
      return;
    }

    // Manually register the first page hit safely on client side
    gtag('config', this.trackingId, {send_page_view: false});
    this.trackPageView(this.router.url);

    // Subscribe to SPA router changes for subsequent page transitions
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.trackPageView(event.urlAfterRedirects);
    });
  }

  private trackPageView(url: string): void {
    gtag('event', 'page_view', {
      page_path: url,
      send_to: this.trackingId
    });
  }

  // Use this for tracking button clicks or custom UI items
  public trackEvent(eventName: string, params: object = {}): void {
    // Guard tracking events in case they are triggered during unexpected SSR flows
    if (typeof gtag === 'function') {
      if (environment.production) {
        gtag('event', eventName, params);
      }
    }
  }
}
